import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

function Container({ children }) {
  return (
    <div className="container-fluid">
      { children }
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Container;
